import React, { useEffect } from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Waypoint } from "react-waypoint";
import { useLocation } from "react-router-dom";

import {
  Heading,
  Box,
  Flex,
  Button,
  Text,
  UnorderedList,
  ListItem,
  Image,
} from "@chakra-ui/react";
import { Helmet } from "react-helmet";

//data
import AreasOfWork from "./work";
import { Link, NavLink } from "react-router-dom";

//Image
const bg = require("../../assets/images/bg.jpg");
const welcome1 = require("../../assets/images/1.jpg");
const welcome2 = require("../../assets/images/2.jpg");

const Home = () => {
  let params = useLocation();
  useEffect(() => {
    if (params?.state?.id)
      document.querySelector(`${params.state.id}`).scrollIntoView(true);
    else window.scrollTo(0, 0);
  }, [params.state, useLocation().state]);

  return (
    <Flex flexDirection={"column"} alignItems={"center"}>
      <Helmet>
        <title>AKIA</title>

        <meta
          title="Best Engineering design consultant for Process study Calculation"
          content="Get the Top Design Consultant for Water Treatment & Network Hydraulic Analysis, Akia-engineering provides Perform Process Simulation using Aspen HYSYS."
        />
        <meta
          name="keywords"
          content="Best Engineering Design Consultant for Process Studies and Calculations"
        />
        <meta
          name="keywords"
          content="Top Design Consultant for Water Treatment and Network Hydraulic Analysis"
        />
        <meta
          name="keywords"
          content="Perform Process Simulation using Aspen HYSYS"
        />
      </Helmet>
      {/* Top Landing Secintion */}
      <Flex
        w={"100vw"}
        h={"100vh"}
        maxHeight={"1440px"}
        bg={`linear-gradient(rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0.82))`}
        background={`linear-gradient(rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0.82)), url(${bg})`}
        backgroundSize={"cover"}
        alignItems={"center"}
        justifyContent={"center"}
        flexDirection={"column"}
      >
        <Flex flexDirection={"column"} alignItems="center" px={"2rem"}>
          <Flex overflow={"hidden"} w={"100%"} maxW={"100rem"} pos={"relative"}>
            <Waypoint
              onEnter={() =>
                (document.querySelector("#animateMain1").style.animation =
                  "heading 1.5s ease-out")
              }
            >
              <Flex id="animateMain1">
                <Heading
                  flexShrink={"0"}
                  textTransform={"uppercase"}
                  fontSize={{ base: "3.7rem", "3sm": "4.5rem", lg: "5.5rem" }}
                  maxW={"100rem"}
                  color={"whiteAlpha.900"}
                  fontFamily={"Roboto Condensed, Lato, sans-serif"}
                  textAlign="center"
                  w={"100%"}
                >
                  Engineering for Success
                </Heading>
                <Box flexShrink={"0"} bg={"whiteAlpha.900"} w={"100%"}></Box>
              </Flex>
            </Waypoint>
          </Flex>
          <Flex my={"1rem"} overflow={"hidden"} pos={"relative"}>
            <Waypoint
              onEnter={() =>
                (document.querySelector("#animateMain2").style.animation =
                  "heading 1.5s ease-out")
              }
            >
              <Flex id="animateMain2">
                <Heading
                  textTransform={"uppercase"}
                  fontSize={{ base: "2rem", "3sm": "2.5rem", lg: "2.5rem" }}
                  textAlign={"center"}
                  fontWeight={"300"}
                  color={"whiteAlpha.900"}
                  fontFamily={"Roboto Condensed, Lato, sans-serif"}
                  pos={"relative"}
                  flexShrink={0}
                  width={"100%"}
                >
                  a multi-disciplinary Engineering design firm
                </Heading>
                <Box flexShrink={"0"} bg={"whiteAlpha.900"} w={"100%"}></Box>
              </Flex>
            </Waypoint>
          </Flex>

          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate4").style.animation =
                "fadeUp 1.5s")
            }
          >
            <NavLink to={{ pathname: "/contact" }}>
              <Button
                id="animate4"
                bg={"#EA0F0F"}
                color={"whiteAlpha.900"}
                borderRadius={"0"}
                mt={"2rem"}
                fontSize="2rem"
                fontWeight={700}
                p={"2.5rem 5rem"}
                textTransform={"uppercase"}
                outline={"3px solid #EA0F0F"}
                outlineOffset={"5px"}
                transition={"all 0.3s ease"}
                _hover={{
                  outlineOffset: "0px",
                }}
              >
                Get in Touch
              </Button>
            </NavLink>
          </Waypoint>
        </Flex>

        <Flex
          transform={"translateY(4rem)"}
          cursor={"pointer"}
          w={"2.5rem"}
          h={"1.75rem"}
          bg={"rgba(255,255,255, 0.3)"}
          clipPath={"polygon(0 0, 50% 25%, 100% 0, 100% 75%, 50% 100%, 0 75%)"}
          justify={"center"}
          onClick={() => {
            document.querySelector("#welcomeSection").scrollIntoView({
              behavior: "smooth",
            });
          }}
        >
          <Box
            w={"2.5rem"}
            h={"2.25rem"}
            bg={"whiteAlpha.900"}
            animation={"arrow 1.75s infinite"}
          ></Box>
        </Flex>
      </Flex>

      {/* Next Section */}
      <Flex
        alignItems={"center"}
        flexDirection={"column"}
        px={"4rem"}
        py={"8rem"}
        maxW="1440px"
        w={"100%"}
      >
        <Flex
          mb={"1.5rem"}
          overflow={"hidden"}
          pos={"relative"}
          width={"fit-content"}
          id={"welcomeSection"}
        >
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate8").style.animation =
                "heading 1.5s ")
            }
          >
            <Flex id="animate8">
              <Heading
                textAlign={"center"}
                mt={0}
                textTransform={"uppercase"}
                fontSize={{ base: "3rem", "3sm": "4rem", lg: "5rem" }}
                flexShrink={"0"}
                width={"100%"}
              >
                <Text
                  fontSize={{ base: "2rem", "3sm": "2.5rem", lg: "3rem" }}
                  fontWeight="400"
                >
                  Welcome to
                </Text>
                AKIA Engineering
              </Heading>
              <Box bg={"black"} h={"100%"} w={"100%"} flexShrink={"0"}></Box>
            </Flex>
          </Waypoint>
        </Flex>
        <Box bg={"#EA0F0F"} h="5px" w={"10rem"} mt={"2.5rem"}></Box>

        <Flex
          fontSize={"2rem"}
          flexDirection={"column"}
          mt={"8rem"}
          width={"100%"}
        >
          <Flex flexDirection={{ base: "column-reverse", md: "row" }}>
            <Flex
              pt={{ base: "4rem", md: "2rem" }}
              flex={{ base: "0 1 50%" }}
              flexDirection={"column"}
              alignItems={{ base: "center", md: "flex-start" }}
              textAlign={{ base: "justify", md: "left" }}
            >
              <Flex
                mb={"1.5rem"}
                overflow={"hidden"}
                pos={"relative"}
                width={"fit-content"}
              >
                <Waypoint
                  onEnter={() =>
                    (document.querySelector("#animate1").style.animation =
                      "heading 1.5s ")
                  }
                >
                  <Flex id="animate1">
                    <Heading
                      flexShrink={"0"}
                      textTransform={"uppercase"}
                      fontSize={{ base: "2.2rem", "3sm": "3rem" }}
                      w={"100%"}
                      pos="relative"
                      textAlign={"center"}
                    >
                      Our Qualities
                    </Heading>

                    <Box flexShrink={"0"} bg={"black"} w={"100%"}></Box>
                  </Flex>
                </Waypoint>
              </Flex>
              <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
              <Text
                fontSize={{ base: "1.7rem", xl: "2rem" }}
                maxW={{ base: "90%", md: "85%", lg: "80%" }}
                textAlign={{ base: "justify", md: "left" }}
              >
                AKIA Engineering is a multi-disciplinary Engineering design firm
                with competent and full expertise in Engineering with -<br /> •
                Highly professional and experienced design engineers <br /> •
                Innovative and economical design approach <br />• Provides Value
                Engineering design solution
              </Text>
            </Flex>
            <Waypoint
              onEnter={() =>
                (document.querySelector("#animate6").style.animation =
                  "fadeUp 1.5s")
              }
            >
              <Flex
                id="animate6"
                height={"400px"}
                flex={{
                  base: "0 1 250px",
                  "2sm": "0 1 300px",
                  "3sm": "0 1 400px",
                  md: "0 1 50%",
                }}
                bgImage={`url(${welcome1})`}
                backgroundPosition="center"
                backgroundSize={"cover"}
                justify={"center"}
                alignItems={"center"}
                boxShadow={"0 0 10px 10px rgba(0,0,0,0.08)"}
              ></Flex>
            </Waypoint>
          </Flex>
          <Flex
            mt={{ base: "4rem", md: "0" }}
            flexDir={{ base: "column", md: "row" }}
          >
            <Waypoint
              onEnter={() =>
                (document.querySelector("#animate5").style.animation =
                  "fadeUp 1.5s")
              }
            >
              <Flex
                id="animate5"
                h={"400px"}
                bgImage={`url(${welcome2})`}
                backgroundPosition="center"
                backgroundSize={"cover"}
                justify={"center"}
                alignItems={"center"}
                boxShadow={"0 0 10px 10px rgba(0,0,0,0.2)"}
                flex={{
                  base: "0 1 250px",
                  "2sm": "0 1 300px",
                  "3sm": "0 1 400px",
                  md: "0 1 50%",
                  lg: "0 1 50%",
                }}
              ></Flex>
            </Waypoint>
            <Flex
              pl={{ base: "0rem", md: "5rem", lg: "10rem" }}
              pt={{ base: "4rem", md: "12rem" }}
              flex={"0 50%"}
              flexDirection={"column"}
              alignItems={{ base: "center", md: "flex-start" }}
            >
              <Flex
                mb={"1.5rem"}
                overflow={"hidden"}
                pos={"relative"}
                width={"fit-content"}
              >
                <Waypoint
                  onEnter={() =>
                    (document.querySelector("#animate2").style.animation =
                      "heading 1.5s ")
                  }
                >
                  <Flex id="animate2">
                    <Heading
                      flexShrink={"0"}
                      textTransform={"uppercase"}
                      fontSize={{ base: "2.2rem", "3sm": "3rem" }}
                      w={"100%"}
                      textAlign={"center"}
                      pos="relative"
                    >
                      Our Expertise
                    </Heading>

                    <Box flexShrink={"0"} bg={"black"} w={"100%"}></Box>
                  </Flex>
                </Waypoint>
              </Flex>
              <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
              <Text fontSize={{ base: "1.7rem", xl: "2rem" }}>
                AKIA Engineering under take projects in -
              </Text>
              <UnorderedList
                fontSize={{ base: "1.7rem", xl: "2rem" }}
                maxW={"70%"}
              >
                <ListItem>Oil & Gas (Offshore& Onshore)</ListItem>
                <ListItem>Petrochemical</ListItem>
                <ListItem>Water Treatment</ListItem>
              </UnorderedList>
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      {/* Next Section */}
      <Flex
        width="100vw"
        alignItems={"center"}
        flexDirection={"column"}
        py={"8rem"}
        bg={"#F5F5F5"}
        // bg={"#F0F0F0"}
      >
        <Flex
          mb={"1.5rem"}
          overflow={"hidden"}
          pos={"relative"}
          width={"fit-content"}
        >
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate7").style.animation =
                "heading 1.5s ")
            }
          >
            <Flex id="animate7">
              <Heading
                textTransform={"uppercase"}
                fontSize={{ base: "3rem", "3sm": "4rem", lg: "5rem" }}
                fontFamily={"Roboto Condensed, Lato, sans-serif"}
                textAlign="center"
                flexShrink={0}
                w={"100%"}
                px={"2rem"}
              >
                Our Areas of Work
              </Heading>
              <Box flexShrink={0} bg={"black"} height={"100%"} w={"100%"}></Box>
            </Flex>
          </Waypoint>
        </Flex>
        <Box
          zIndex={"10"}
          bg={"#EA0F0F"}
          h="5px"
          w={"10rem"}
          mb={"7rem"}
          mt={"1rem"}
        ></Box>

        <Waypoint
          onEnter={() =>
            (document.querySelector("#animate3").style.animation =
              "fadeUp 1.5s")
          }
        >
          <Flex
            id="animate3"
            flexWrap={"wrap"}
            justifyContent="space-evenly"
            gap={"2rem"}
            maxW={"1440px"}
            px="3rem"
          >
            {AreasOfWork.map((area, index) => (
              <Flex
                key={index}
                flex={"1"}
                mb="2rem"
                py={"2rem"}
                borderRadius={"5px"}
                alignItems={"center"}
                flexDirection={"column"}
                _hover={{
                  transform: "scale(1.03)",
                  boxShadow: "0 0 5px 5px rgba(0,0,0,0.08)",
                }}
                transition={"all 0.3s ease-in-out"}
              >
                <Box
                  bgImage={area.image}
                  height={{ base: "170px", sm: "200px", "2sm": "250px" }}
                  w={{ base: "190px", sm: "225px", "2sm": "300px" }}
                  backgroundPosition="center"
                  backgroundSize={"cover"}
                ></Box>
                <Heading
                  textAlign={"center"}
                  textTransform={"uppercase"}
                  mt={"2rem"}
                >
                  {area.name}
                </Heading>
                <Link
                  key={index}
                  to={{ pathname: area.url }}
                  state={{ id: area.id }}
                >
                  <Text
                    mt={"1rem"}
                    cursor={"pointer"}
                    fontWeight={"700"}
                    fontSize={"1.7rem"}
                    color={"#EA0F0F"}
                  >
                    Know More
                  </Text>
                </Link>
              </Flex>
            ))}
          </Flex>
        </Waypoint>
      </Flex>
      <Flex
        width={"100vw"}
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDirection={{ base: "column", md: "row" }}
        py={"6rem"}
      >
        <Heading
          textTransform={"uppercase"}
          fontWeight={"700"}
          fontSize={{ base: "2.5rem", md: "4rem" }}
        >
    Connect with us
        </Heading>
        <Flex alignItems={"center"} mt={{ base: "2rem", md: "0" }}>
          <a
                      id="phone"
                      style={{ flex: "0 0 22%" }}
                      href="https://wa.me/+971501232838"
                    >
                      
                        <Heading fontSize={"4rem"}>
                          <i
                            className="fa-brands fa-square-whatsapp"
                            style={{ color: "green" }}
                          />
                        </Heading>
                        
                        
                      
                    </a>

          <a href="https://www.linkedin.com/company/akia-flow-assurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-linkedin"
            ></i>
          </a>

          <a href="https://www.youtube.com/@AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-youtube"
            ></i>
          </a>



          <a href="https://www.facebook.com/AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-facebook"
            ></i>
          </a>
          <a href="https://www.instagram.com/akiaflowassurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-instagram"
            ></i>
          </a>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Home;
